import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import classNames from 'classnames';

// actions
import {
  setActiveProductYear,
  updateActiveField
} from 'current';

// selectors
import { getFieldsForFieldSelector } from 'fields/selectors';
import { getActiveProductYear, getActiveFieldUuid } from 'current/selectors';
import { getProductYearsForScripts } from 'scripts/selectors';

// components
import { Dropdown } from '@tcc/crate';
import ProductYearSelector from 'manage/ProductYearSelector';

const baseString = 'vra-manage-filters-container';
const classString = classNames({
  [`${baseString}`]: true
});
let ManageFiltersContainer = ({
  activeFieldUuid,
  activeProductYear,
  availableProductYears,
  onSelectField,
  onSelectProductYear,
  operationFields
}) => {
  const options = operationFields.map( (field) => {
    return {
      id: field.uuid,
      value: field.name
    };
  });

  const selectedField = operationFields.find(field => field.uuid === activeFieldUuid);

  return (
    <nav className={classString}>
      <Dropdown
        className={`${baseString}__field-selector`}
        options={options}
        searchable
        selectedId={selectedField && selectedField.uuid}
        setValue={(_, id) => { onSelectField(id); }}
        showReset={false}
        testId={`${baseString}__field-selector`}
        value={selectedField && selectedField.uuid}
      />
      <ProductYearSelector
        onChange={onSelectProductYear}
        productYears={availableProductYears}
        selected={activeProductYear}
      />
    </nav>
  );
};


ManageFiltersContainer.propTypes = {
  activeFieldUuid: propTypes.string.isRequired,
  activeProductYear: propTypes.string,
  availableProductYears: propTypes.array.isRequired,
  onSelectField: propTypes.func.isRequired,
  onSelectProductYear: propTypes.func,
  operationFields: propTypes.array
};

ManageFiltersContainer = connect(
  (state) => {
    return {
      activeFieldUuid: getActiveFieldUuid(state),
      activeProductYear: getActiveProductYear(state),
      availableProductYears: getProductYearsForScripts(state),
      operationFields: getFieldsForFieldSelector(state)
    };
  },
  (dispatch) => {
    return {
      onSelectProductYear: (value) => dispatch(setActiveProductYear(value)),
      onSelectField: (value) => {
        dispatch(updateActiveField(value));
      }
    };
  }
)(ManageFiltersContainer);
export default ManageFiltersContainer;
